export default __webpack_public_path__ + "static/media/wellness4.0596dc74.jpeg";